import { AUTH_TOKEN_COOKIE } from "@lib/constants"

// Shared auth utilities that work on both client and server

export const AUTH_TOKEN_EXPIRY_HOURS = 3
export const AUTH_TOKEN_EXPIRY_SECONDS = AUTH_TOKEN_EXPIRY_HOURS * 60 * 60

export const isValidAuthToken = (token: string | null): boolean => {
  if (!token) return false
  return token.length > 10 && !token.includes(" ")
}

// For bearer tokens, we don't decode expiry client-side - let the server handle it
export const isTokenExpired = (_token: string): boolean => {
  return false // Server will hopefully handle expiry validation
}

// Server-side auth utilities
export const createSecureCookieOptions = (isProduction: boolean) => ({
  secure: isProduction,
  sameSite: "strict" as const,
  path: "/",
  httpOnly: false, // Auth token needs client access
})

// Client-side auth utilities
export const clearAuthCookie = () => {
  if (typeof window === "undefined") return

  document.cookie = `${AUTH_TOKEN_COOKIE}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict`

  // Notify about cookie change
  if (typeof BroadcastChannel !== "undefined") {
    const channel = new BroadcastChannel("auth-sync")
    try {
      channel.postMessage({ type: "COOKIE_CHANGE", key: AUTH_TOKEN_COOKIE, value: "" })
    } finally {
      channel.close()
    }
  } else {
    window.dispatchEvent(
      new CustomEvent("cookieChange", {
        detail: { key: AUTH_TOKEN_COOKIE, value: "" },
      })
    )
  }
}

// Auth state helpers
export const getAuthState = (token: string | null) => ({
  isAuthenticated: Boolean(token && isValidAuthToken(token)),
  token,
  isExpired: token ? isTokenExpired(token) : false,
})
